export default {
  providers: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    '& > *': {
      marginTop: '8px',
      '&:first-child': {
        marginTop: '0'
      }
    }
  },
  pending: {
    opacity: '0.5',
    pointerEvents: 'none'
  }
}
